import { IconProps } from "@/core/global-data/dataInterface.data";


const SearchIcon = ({ width = '16', height = '16', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.66683 14.0002C11.1646 14.0002 14.0002 11.1646 14.0002 7.66683C14.0002 4.16903 11.1646 1.3335 7.66683 1.3335C4.16903 1.3335 1.3335 4.16903 1.3335 7.66683C1.3335 11.1646 4.16903 14.0002 7.66683 14.0002Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.6668 14.6668L13.3335 13.3335"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};

export default SearchIcon;
